// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"h4-z"};